<template>
    <lazy-load-component root-margin="600px 0px 600px 0px" @loaded="loadData()">
        <CarouselBox
            v-for="(carousel, index) in addonSaleAreas"
            :key="index"
            :title="carousel.title"
            :products="carousel.products"
            :item-list-name="`${itemListName}${index}`"
            luigis-box-carousel-type="item_detail"
            :luigis-box-item-ids="productUrl"
            class="carouselBox--fullWidth"
        />
    </lazy-load-component>
    <SkeletonProductCarouselSkeleton v-if="!loaded" />
</template>

<script lang="ts">
import CarouselBox from '~/components/elements/CarouselBox.vue'
import ProductAddonSaleAreasResponsePart from '~/models/Api/ProductAddonSaleAreasResponsePart'
import LazyLoadComponent from '~/components/LazyLoadComponent.vue'
import { GtmItemListNameEnum } from '~/models/DataLayer/GtmItemListNameEnum'

export default {
    components: {
        LazyLoadComponent,
        CarouselBox,
    },

    props: {
        productId: {
            type: Number,
            required: true,
        },
        productUrl: {
            type: String,
            default: '',
        },
    },

    data() {
        return {
            loaded: false,
            addonSaleAreas: [] as ProductAddonSaleAreasResponsePart[],
        }
    },

    computed: {
        itemListName(): string {
            return GtmItemListNameEnum.ProductDetailCarousel
        },
    },

    methods: {
        async loadData() {
            this.addonSaleAreas = await this.$repository.getProductAddonSaleAreas(this.productId)
            this.loaded = true
        },
    },
}
</script>
